import React, {Component} from 'react'

class TableHeadReport extends Component {
    render() {
        const {dataLabels} = this.props
        return (
            <thead className="TableHeadReport">
                <tr>
                    <th></th>
                    {
                        dataLabels.length > 0 && dataLabels.map(label => {
                            return <th>{label}</th>
                        })
                    }
                </tr>
            </thead>
        )
    }
}

export default TableHeadReport
